import { createApp } from 'vue';
import App from './App.vue';
import { registerPlugins } from '@/plugins'
import axios from 'axios';
import VueApexCharts from 'vue3-apexcharts';

// App initialization
const app = createApp(App);

registerPlugins(app);

app.component('ApexChart', VueApexCharts);
app.config.globalProperties.$axios = axios;

app.mount('#app');